import React, { useState } from "react";

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  options: SelectOption[];
  label: string;
  name: string;
  placeholder: string;
  value?: string;
  errors?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.FC<SelectProps> = ({
  options,
  label,
  name,
  placeholder,
  value,
  errors,
  onChange,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value || "");

  return (
    <div className="flex w-full flex-col gap-2">
      <label className="text-cream-800 dark:text-cream-400 text-sm font-medium">
        {label}
      </label>
      <select
        name={name}
        value={selectedValue}
        onChange={(e) => {
          setSelectedValue(e.target.value);
          onChange?.(e);
        }}
        className={`border-cream-500 dark:bg-cream-800 w-full rounded border font-medium ${
          selectedValue === ""
            ? "text-cream-600 dark:text-cream-500"
            : "text-cream-950 dark:text-cream-100"
        }`}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors && (
        <span className="text-peach-600 dark:text-peach-400 text-sm font-semibold">
          {errors}
        </span>
      )}
    </div>
  );
};

export default Select;
